import dayjs from 'dayjs'

export function padTo2Digits(num: number) {
    return num.toString().padStart(2, '0')
}

export const getHMSfromS = (timeInS: number) => {
    let seconds = Math.floor(timeInS)
    let minutes = Math.floor(seconds / 60)
    let hours = Math.floor(minutes / 60)

    seconds = seconds % 60
    minutes = minutes % 60
    hours = hours % 24

    return `${hours !== 0 ? padTo2Digits(hours) + ':' : ''}${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`
}

export const getTextTimer = (remainingTime: number) => {
    const minutes = String(Math.trunc(remainingTime / (60 * 1000))).padStart(2, '0')
    const seconds = String(Math.trunc(remainingTime / 1000) % 60).padStart(2, '0')
    return minutes + ':' + seconds
}

export const getCreationDateFromSimulation = (sim: Simulation) => {
    const date = dayjs(sim.created_at)
    const dayWeek = new Date().toLocaleString(process.env.NEXT_PUBLIC_APP_LOCALE, { weekday: 'long' })
    return dayWeek + date.locale(process.env.NEXT_PUBLIC_APP_LOCALE || 'it').format(' DD MMMM')
}

export const getCreationDateFromQuiz = (quiz: Quiz) => {
    const date = dayjs(quiz.created_at)
    const dayWeek = new Date().toLocaleString(process.env.NEXT_PUBLIC_APP_LOCALE, { weekday: 'long' })
    return dayWeek + date.locale(process.env.NEXT_PUBLIC_APP_LOCALE || 'it').format(' DD MMMM')
}
